import type { SVGProps } from 'react';

const SvgMessageError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m7 9c0 1.57-.53 3.02-1.4 4.18L7.82 6.4C8.99 5.52 10.43 5 12 5c3.86 0 7 3.14 7 7M5 12c0-1.57.53-3.02 1.4-4.18l9.78 9.78c-1.17.88-2.61 1.4-4.18 1.4-3.86 0-7-3.14-7-7"
    />
  </svg>
);
export default SvgMessageError;
